<template>
    <div>
        <h4 class="text-uppercase">
            Contact Us
        </h4>
        <div class="form">
            <div id="sendmessage">Your message has been sent. Thank you!</div>
            <div id="errormessage"></div>
            <form action="" method="post" role="form" class="contactForm">
              <div class="form-group">
                  <input type="text" name="name" class="form-control" id="name" placeholder="Name" v-model="name"/>
              </div>
              <div class="form-group">
                  <input type="text" name="phone" class="form-control" id="phone" placeholder="Phone Number" v-model="phone"/>
              </div>
              <div class="form-group">
                  <input type="email" class="form-control" name="email" id="email" placeholder="Email" v-model="email"/>
              </div>
              <div class="form-group">
                  <input type="text" class="form-control" name="subject" id="subject" placeholder="Subject" v-model="subject"/>
              </div>
              <div class="form-group">
                  <textarea class="form-control" name="message" rows="5" placeholder="Message" v-model="message" />
              </div>
               <div v-if="errors.length">
              <div>Please correct the following error(s):</div>
                <ul>
                  <li v-for="error in errors" :key="error">{{ error }}</li>
                </ul>
              </div>
              <div v-if="showSuccess">
                Message Sent!
              </div>
              <div>
                  <div class="g-recaptcha" data-sitekey="6Lern1EUAAAAANRl7_Y68w8Y8YsfvzYmb7DVPIno" data-theme="dark"></div>
                  <input type="button" value="Send Message" @click="sendEmail"/>
              </div>
            </form>
        </div>
    </div>
</template>

<script>
import request from "request";

export default {
  name: "ContactUs",
  data() {
    return {
      name: "",
      phone: "",
      email: "",
      subject: "",
      message: "",
      showSuccess: false,
      errors: []
    };
  },
  methods: {
    sendEmail: function() {
      this.showSuccess = false;
      this.errors = this.validateForm();
      if (this.errors && this.errors.length > 0) {
        return;
      }

      const token = grecaptcha.getResponse();
      if (!token) return;
      grecaptcha.reset();
      let self = this;

      this.postData('https://xdnvqbhzy9.execute-api.us-east-1.amazonaws.com/prod/contactUsForm', {
        name: this.name,
        phone: this.phone,
        email: this.email,
        subject: this.subject,
        message: this.message,
        captchaResponse: token
      })
        .then(
          function(data) {
            self.showEmailSuccess();
          },
          function(error) {
            console.error("email promise fail");
            self.errors.push(error);
          }
        )
        .catch(function(error) {
          console.error("error", error);
        });
    },

    validateForm: function() {
      let errors = [];

      if (!this.name) errors.push("Name is required");
      if (!this.phone) errors.push("Phone is required");
      if (!this.email) errors.push("Email is required");
      if (!this.subject) errors.push("Subject is required");
      if (!this.message) errors.push("Message is required");

      return errors;
    },

    showEmailSuccess: function() {
      this.showSuccess = true;
      this.name = "";
      this.phone = "";
      this.email = "";
      this.subject = "";
      this.message = "";
    },

    postData: function(url, d) {
      return new Promise(function(resolve, reject) {
        const options = {
          uri: url,
          json: true,
          body: d
        };

        request.post(options, function(error, response, body) {
          if (error) {
            reject(error);
          }

          if (body && response.statusCode !== 200) {
            reject(body.message);
          }
          resolve(body);
        });
      });
    }
  }
};
</script>

<style scoped>
input[type="button"] {
  background: #333;
  border: 0;
  padding: 10px 24px;
  color: #fff;
  transition: 0.4s;
}

button[disabled],
input[disabled] {
  cursor: not-allowed;
  background-color: grey;
}

.g-recaptcha {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ContactUs.vue